import { Component, OnInit, ViewChild } from '@angular/core';
import { InvitationRequestDTO } from '@dto/doctor/InvitationRequestDTO';
import { ViewUtil } from 'app/util/ViewUtil';
import { InviteService } from '@service/InviteService';
import { Constant } from '@common/Constant';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-invite-doctor',
  templateUrl: './InviteDoctorComponent.html',
  styleUrls: [ './InviteDoctorComponent.scss' ]
})
export class InviteDoctorComponent implements OnInit {
  @ViewChild('form') private form: NgForm;

  public data: InvitationRequestDTO = new InvitationRequestDTO();

  public Constant: typeof Constant = Constant;

  constructor(private viewUtil: ViewUtil,
              private inviteService: InviteService) {
  }

  public ngOnInit(): void {
  }

  public invite(): void {
    this.form.onSubmit(null);
    if (this.form.valid) {
      this.inviteService.createDoctorInvitation(this.data).toPromise()
        .then(() => {
          this.form.resetForm();
          this.viewUtil.showToastSuccess('VIEW.MAIN.INVITE.MESSAGE.SUCCESS');
        })
        .catch((err) => {
          this.viewUtil.handleServerError(err);
        });
    }
  }
}
